import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetDevicesInformation = (data) => {
  return rootApi.get('api/device/search', { params: data });
};

export const apiGetDevicesInformationV2 = (data) => {
  return rootApi.get('api/v2/device/search', { params: data });
};
export const apiGetOriginalData = (data) => {
  return rootApi.get('api/original-data/search', { params: data });
};

export const apiExportOriginalData = (data) => {
  return rootApi.get('api/original-data/export-report', { params: data });
};

export const apiGetReturnCmd = (data) => {
  return rootApi.get('api/return-cmd/search', { params: data });
};

export const apiGetLinkDown = (data) => {
  return rootApi.get('api/down-link-command/search', { params: data });
};

export const apiCheckDeviceExist = (data) => {
  return rootApi.get('api/v2/device/check', { params: data });
};

export const apiCreateLinkDown = (data) => rootApi.post('api/down-link-command/create', data);

export const apiDeleteLinkDown = (id) => rootApi.delete(`api/down-link-command/delete/${id}`);

export const apiGetUserInfo = (data) => {
  return rootApi.get('api/getUserInfo');
};

export const apiCreateDevice = (data) => rootApi.post('api/device', data);
export const apiUpdateDevice = (data, id) => rootApi.put(`api/device/${id}`, data);
export const apiDeleteDevice = (id) => rootApi.delete(`api/device/${id}`);

export const apiGetDeviceById = (id) => {
  return rootApi.get(`api/device/${id}`);
};

export const apiDownloadTemplate = (data) => rootApi.post('api/device/export-template', data);
export const apiImportExcel = (data) => rootApi.post('api/device/import', data);

export const apiGetListCommunity = () => {
  return rootApi.get(`api/master-data/search?type=COMMUNITY`);
};

export const apiSyncData = () => rootApi.post('api/original-data/sync');

export const apiSyncTimeData = () => rootApi.post('api/original-data/sync-time');

export const apiGetAllReplacements = (data) => {
  return rootApi.get('api/replacements', { params: data });
};

export const apiCreateReplacement = (data) => rootApi.post('api/replacement', data);
export const apiUpdateReplacement = (data, id) => rootApi.put(`api/replacement/${id}`, data);
export const apiDeleteReplacement = (id) => rootApi.delete(`api/replacement/${id}`);

export const apiGetReplacementById = (id) => rootApi.get(`api/replacement/${id}`);

export const apiDownloadReplacementTemplate = (data) =>
  rootApi.post('api/replacement/export-template', data);
export const apiImportReplacementExcel = (data) => rootApi.post('api/replacement/import', data);

export const apiGetAllConfigs = (data) => {
  return rootApi.get('api/configs', { params: data });
};

export const apiCreateConfig = (data) => rootApi.post('api/config', data);
export const apiUpdateConfig = (data, id) => rootApi.put(`api/config/${id}`, data);
export const apiUpdateConfigV2 = (data, id) => rootApi.put(`api/v2/config/${id}`, data);
export const apiDeleteConfig = (id) => rootApi.delete(`api/config/${id}`);

export const apiGetConfigById = (id) => rootApi.get(`api/config/${id}`);

export const apiDownloadConfigTemplate = (data) => rootApi.post('api/config/export-template', data);
export const apiImportConfigExcel = (data) => rootApi.post('api/config/import', data);

export const apiGetAllWarnings = (data) => {
  return rootApi.get('api/device/warning/search', { params: data });
};

export const apiResolvedWarning = (id) => rootApi.put(`api/device/warning/${id}`);
